import { newE2EPage } from '@stencil/core/testing';

describe('jackery-form-item', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-form-item></jackery-form-item>');

    const element = await page.find('jackery-form-item');
    expect(element).toHaveClass('hydrated');
  });
});
